<template>
	<div class="page">
		<Tip tip="各商城订单中商品销售统计。" />
		<el-form :inline="true" :model="tableParams" class="condition">
            <el-form-item label="">
				<el-date-picker style="max-width:240px"
					v-model="tableParams.created_date"
					type="daterange"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					placeholder="选择时间范围"
					value-format="yyyy-MM-dd" >
				</el-date-picker>
            </el-form-item>
            <el-form-item label="">
                <el-select v-model="tableParams.shop_id" placeholder="请选择商城">
                    <el-option label="请选择" :value="0" disabled></el-option>
                    <el-option :label="item.shop_name" :value="item.shop_id" v-for="(item,index) in shopList" :key="index"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label=" ">
                <el-button @click="onSearchBind()">筛选</el-button>
            </el-form-item>
        </el-form>
		<div class="block">
			<div class="title">
				<div>商品分类销量</div>
			</div>
			<div class="table" style="display: flex;" v-loading="otherLoading">
				<el-table :data="caterankObj" style="width: 100%;" 
				:cell-style="{border:'none'}" 
				:header-cell-style="{fontSize:'16px',border:'none'}">
					<el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
					<el-table-column prop="cate_name" label="分类名称" align="center"></el-table-column>
					<el-table-column prop="quatity" label="销售量" align="center"></el-table-column>
					<el-table-column prop="amount" label="销售额" align="center"></el-table-column>
					<el-table-column prop="percent" label="占比" align="center"></el-table-column>
				</el-table>
				<div style="border-right:1px solid #eee;margin:0 40px"></div>
				<el-table :data="caterankObj1" style="width: 100%;" 
				:cell-style="{border:'none'}"
				:header-cell-style="{fontSize:'16px',border:'none'}">
					<el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
					<el-table-column prop="cate_name" label="分类名称" align="center"></el-table-column>
					<el-table-column prop="quatity" label="销售量" align="center"></el-table-column>
					<el-table-column prop="amount" label="销售额" align="center"></el-table-column>
					<el-table-column prop="percent" label="占比" align="center"></el-table-column>
				</el-table>
			</div>
		</div>
		<div class="block">
			<div class="title">
				<div>分类曲线</div>
			</div>
			<div class="echarts" id="echarts" v-loading="shopLoad">
			</div>
		</div>
		
		<div class="table">
			<div class="title">
				<div>
					商品销量排行
					<el-input v-model="tableParams.good_name" placeholder="请输入商品名称" size="medium" clearable style="margin: 0 20px;width: 200px;"></el-input>
					<el-button size="medium" @click="initData({page:1})">筛选</el-button>
				</div>
				<el-tooltip class="item" effect="dark" content="Top Left 提示文字" placement="top-start">
					<div slot="content">
						计算说明:<br/>毛利=(销售金额-退货金额)-(销售成本-退货成本)<br/>毛利率=毛利/(销售金额-退货金额)<br/>毛利统计为已收货后的订单
					</div>
					<el-button size="medium" type="info"><i class="el-icon-warning-outline" style="margin-right:5px"></i>说明</el-button>
				</el-tooltip>
				
			</div>
			<el-table :data="tableData" style="width: 100%" 
			:header-cell-style="{ background:'#e3e3e3',color:'#000',fontSize:'16px'}" v-loading="tableLoading">
				<el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
				<el-table-column prop="date" label="商品">
					<template slot-scope="scope">
						<div class="goods_name"><label>商品：</label>{{scope.row.good_name}}</div>
						<div class="goods_name"><label>分类：</label>{{scope.row.cate.join('、')}}</div>
					</template>
				</el-table-column>
				<el-table-column prop="real_sale" label="销量" width="180" align="center"></el-table-column>
				<el-table-column prop="cost_price" label="成本" align="center"></el-table-column>
				<el-table-column prop="cost_amount" label="销售成本" align="center"></el-table-column>
				<el-table-column prop="sale_avg" label="平均售价" align="center"></el-table-column>
				<el-table-column prop="sale_amount" label="销售金额" align="center"></el-table-column>
				<el-table-column prop="after_cost_amount" label="退货成本" align="center"></el-table-column>
				<el-table-column prop="after_amount" label="退款金额" align="center"></el-table-column>
				<el-table-column prop="profit" label="毛利" align="center"></el-table-column>
				<el-table-column prop="profit_rate" label="毛利率↓" align="center"></el-table-column>
			</el-table>
			<div class="paging">
				<el-pagination background
					@size-change="initData({limit:$event})"
					:current-page.sync="tableParams.page"
					@current-change="initData({page:$event})"
					:page-size="tableParams.limit"
					layout="total, sizes, prev, pager, next, jumper"
					:total="totalNumber"></el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import Tip from "../../../components/Tip/Tip.vue"
    import {shopSelect,shopCatechart,shopCaterank,shopGoodsalerank} from "../../../request/apis.js"
	import * as echarts from 'echarts';
	export default{
		components: {
			Tip
		},
		data(){
			return {
				shopLoad : false,
				otherLoading : false,
				tableData: [],
                tableParams : {
					limit: 10, // 每页显示条目个数
					page: 1, // 当前页数
					created_date : [],
					shop_id : 0,
					good_name : ''
                },
				totalNumber:0,
				shopList : [],
				tableLoading : false,
				catechartObj :{},
				caterankObj :[],
				caterankObj1 :[],
			}
		},
		mounted(){
			this.paramData();
		},
		methods:{
			async paramData(){
                let res  = await shopSelect();
				this.shopList = res.data;
				this.initData({shop_id:res.data[0].shop_id});
			},
			initData(params={}){
				for(var key in params){
					this.tableParams[key]	= params[key];
				}
				this.tableData    = [];
				this._getData()
				if(!params['page']&&!params['limit']){
					this.getShopCaterank();
					this.getShopEcharts()
				}
			},
			onSearchBind(){
				this.tableData = [];
				this.tableParams.page	= 1;
				this.tableParams.good_name	= '';
				this.caterankObj	= [];
				this.caterankObj1	= [];
				this.initData();
			},
			getShopCaterank(){
				this.otherLoading	= true;
				shopCaterank(this.tableParams).then(res=>{
					this.otherLoading	= false;
					(res.data||[]).forEach((s,sk)=>{
						if(sk%2==0){
							this.caterankObj.push(s)
						}else{
							this.caterankObj1.push(s)
						}
					})
                })
			},
            _getData(){
                this.tableLoading = true;
                shopGoodsalerank(this.tableParams).then(res=>{
                    this.tableLoading = false;
                    this.tableData  = res.data||[];
                    this.totalNumber  = Number(res.count)||1;
                })
            },
			//订单商城展示：
			async getShopEcharts() {
				this.shopLoad = true;
				let res = await shopCatechart(this.tableParams);
				let series = [];
				var chartDom = document.getElementById('echarts');
				var myChart = echarts.init(chartDom);
				res.data.map((s,k)=>{
					s.cates.forEach((e,ek) => {
						if(k==0){
							series.push({
								data: [e.count],
								name : e.cate_name,
								type: 'line',
								smooth: true
							})
						}else{
							series[ek].data.push(e.count)
						}
					});
				})
				var option = {
					noDataText : '没有数据',
					legend: {
						top : '20px',
						data: series.map(s=>s.name),
					},
					grid:{
						left:'3%',
						right:'3%',
						top : '60px',
						bottom : '20px'
					},
					xAxis: {
						type: 'category',
						boundaryGap: false,
						data: res.data.map(s=>s.date),
					},
					yAxis: {
						type: 'value',
						axisLine: {
							show: false
						}
					},
					series,
					tooltip : {
					trigger: 'axis',
					backgroundColor : '#fff',
					textStyle : {
						color : '#333',
						fontSize : 12,
						lineHeight : 20
					},
					extraCssText : 'text-align:left;padding:5px 10px',
					axisPointer: {
						type: 'cross',
						label: {
							backgroundColor: 'red'
						}
					}
					}
				};
				option && myChart.setOption(option,{notMerge:true});
				this.shopLoad = false;
			},
		}
	}
</script>

<style scoped>
	.flex{display: flex;justify-content: space-between;margin-top: 20px;}
	.block{padding: 20px 20px 30px;margin-bottom: 30px;box-shadow: 0 0 10px 0 #0000004f;border-radius: 16px;box-sizing: border-box;}
	.echarts{height: 300px;}
	.title{display: flex;justify-content: space-between;align-items: center;font-size: 22px;padding-left: 10px;font-weight: 500;margin-bottom: 15px;}
	.title_dec{font-size: 14px;color: #777;}
	.table{margin-top: 20px;min-height: 200px;}
	.paging{margin: 10px auto 50px;text-align: center;}
	.condition{margin-top: 20px;}
	.el-table::before{display: none;}
	.goods_name label{color: var(--theme-color);}
</style>